<template>
  <!-- 预约投保单 -->
  <div class="wrapper main-container">
    <div class="content">
      <div class="search-box gauge_20">
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">产品</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.userType" :transfer="true">
            <Option value="1">投保人</Option>
            <Option value="2">被保险人</Option>
          </Select>
          <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
        </div>
        <div class="input-item">
          <span class="label">犹豫期截止日</span>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            v-model="searchParams.date"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">质检状态</span>
          <Select v-model="searchParams.confirmRightStatusIn" :transfer="true" clearable multiple>
            <Option value="0">待单录</Option>
            <Option value="1">待质检</Option>
            <Option value="2">质检成功</Option>
            <Option value="-1">质检失败</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">单录方式</span>
          <Select v-model="searchParams.confirmRightMode" :transfer="true" clearable>
            <Option value="1">视频单录</Option>
            <Option value="2">人工回访</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="confirmRightStatusIn">
            <span v-if="row.confirmRightStatus === 0 && row.confirmRightMode == 2">待人工回访</span>
            <span v-else-if="row.confirmRightStatus === 0">待单录</span>
            <span v-else-if="row.confirmRightStatus === 1">待质检</span>
            <span v-else-if="row.confirmRightStatus === 2">质检成功</span>
            <span v-else-if="row.confirmRightStatus === -1">质检失败</span>
            <Poptip trigger="hover" transfer-class-name="my-poptip left0" :transfer="true">
              <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" v-if="row.confirmRightStatus === -1 && row.qualityFailReason" />
              <div slot="content">
                <p>{{ row.qualityFailReason }}</p>
              </div>
            </Poptip>
          </template>
          <template slot-scope="{ row }" slot="sellTypeSlot">
            <div class="sellTypeColumn" v-if="row.sellTypes">
              <Tag color="blue" v-if="row.sellTypes.indexOf('1') != -1">网销</Tag>
              <Tag color="blue" v-if="row.sellTypes.indexOf('3') != -1">经代</Tag>
            </div>
            <div v-else>/</div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click.stop="copyLink(row)" v-if="row.confirmRightStatus === 0 || row.confirmRightStatus === -1">复制确权链接</span>
            <span class="table-btn" @click.stop="$refs.detailModal.open(row)">详情</span>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
        </div>
      </div>
    </div>
    <!-- 线上保单详情  -->
    <detail-modal ref="detailModal"></detail-modal>
  </div>
</template>

<script>
import filters from '@/api/filter';
import { pageTool } from '@/api/mixins';
import detailModal from '@/pages/orderManage/insuredOrder/components/detailModal';

export default {
  components: {
    detailModal
  },
  mixins: [pageTool],
  props: {},
  data() {
    return {
      searchParams: { userType: '1', confirmRightStatusIn: [] },
      columns: [
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          minWidth: 140
        },

        {
          title: '业务类别',
          key: 'sellType',
          align: 'center',
          slot: 'sellTypeSlot',
          width: 100
        },
        {
          title: '产品名称',
          key: 'productName',
          align: 'center',
          minWidth: 230
        },
        {
          title: '投被保人',
          key: 'insuranceName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const res = params.row.insuranceName ? params.row.holderName + '/' + params.row.insuranceName : params.row.holderName;
            return (
              <Tooltip style="width:100%" content={res}>
                <div class="txt-ellipsis2" style="display:block">
                  {res}
                </div>
              </Tooltip>
            );
          }
        },
        {
          title: '承保日期',
          key: 'insureTime',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const res = filters.filterTime(params.row.insureTime, 'YYYY-MM-DD');
            return <span>{res}</span>;
          }
        },
        {
          title: '犹豫期',
          key: 'hesitateDate',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const res = params.row.hesitateDate ? filters.filterTime(params.row.hesitateDate, 'YYYY-MM-DD') : '';
            return <span>{res}</span>;
          }
        },
        {
          title: '质检状态',
          slot: 'confirmRightStatusIn',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '风险原因',
          key: 'riskReason',
          width: 160,
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '180',
          fixed: 'right'
        }
      ],
      tableDate: []
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.initListAjax('/buz/policy/read/list');
  },
  methods: {
    // 转化参数
    setListParams(params) {
      params.confirmRightStatusNotNull = 1;
      if (params.date && params.date[0]) {
        params.hesitateTimeStart = this.$units.formatDate(params.date[0]);
        params.hesitateTimeEnd = this.$units.formatDate(params.date[1]);
      }
      delete params.date;
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      delete params.userType;
      delete params.name;
      delete params.applyOrgId;
    },
    // 复制确权链接
    copyLink(item) {
      this.$http({
        url: '/buz/policy/queryConfirmRightUrl',
        type: 'GET',
        data: { policyNo: item.policyNo }
      }).then(res => {
        if (res.data) {
          this.$units.copyUrl(res.data);
        } else {
          this.$notice.msg('获取确权链接失败');
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper .content {
  padding-bottom: 0;
  overflow: hidden;
  .table-box {
    .detail {
      .btn {
        color: #236dff;
        font-size: 13px;
        cursor: pointer;
      }
      .disabled {
        color: #666;
        cursor: default;
      }
    }
  }
}
</style>
